import React, { useEffect, useState } from "react";
import Page from "./Page";
import { Accordion } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HelpCenter.scss"; // Assuming you have a CSS file for styling
import SessionRequest from "../components/home/SessionRequest";
import { useSelector } from "react-redux";
import _ from "lodash";

function CoachingCenter() {
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [coachUrl, setCoachUrl] = useState("");

  useEffect(() => {
    let userDetailResLocal = userDetailRes;
    console.log("userDetailResLocal", userDetailResLocal);
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal?.status === "success") {
        let journey = userDetailResLocal?.payload?.payload?.money_journey;
        setCoachUrl(journey?.coach);
      }
    }
  }, [userDetailRes]);

  return (
    <Page>
      <div className="help-center">
        <div className="icon mb-3">
          {false && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="64"
              height="64"
              fill="currentColor"
            >
              <rect x="4" y="12" width="4" height="8" rx="1" />
              <rect x="10" y="8" width="4" height="12" rx="1" />
              <rect x="16" y="4" width="4" height="16" rx="1" />

              <path
                d="M10.707 15.707l-1.414-1.414L15.586 8H13V6h6v6h-2V9.414z"
                fill="#00AA00"
              />
            </svg>
          )}
        </div>
        <div className="contact-box text-start">
          <SessionRequest coach={coachUrl} />
        </div>
      </div>
    </Page>
  );
}

export default CoachingCenter;
